<template>
  <!-- Title comes from the hosting InfoCard (Phase 3 editor template). -->
  <div class="bindings-actions">
    <BindingDialog mode="add" @add="addBinding"/>
  </div>

  <!-- Debugging Helper -->
  <!-- <pre class="overflow-y-scroll h-60">Bindings from Subscription Bindings Component: {{ bindings }}</pre> -->

  <BindingsList v-model="bindings" />
</template>

<script setup lang="ts">
import BindingDialog from './BindingDialog.vue';
import BindingsList from './BindingsList.vue';
import { ref, watch } from 'vue';
const props = defineProps(['modelValue']);
const emit = defineEmits(['update:modelValue']);

const bindings = ref(props.modelValue);
watch([bindings], () => {
  emit('update:modelValue', bindings);
}, { deep: true });

function addBinding(binding: any) {
  bindings.value.push(binding)
}
</script>

<style lang="scss" scoped>
.bindings-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  /* Add Binding as a BUI secondary CTA; expander wrapper hugs the button. */
  :deep(.button) {
    background-color: var(--bui-cta-sec-fill, #4b1886);
    color: var(--bui-cta-sec-text, #fffcfd);
    border-radius: var(--bui-ter-radius, 8px);
    text-transform: none;
    font-weight: 500;
    box-shadow: none;
    height: 2.2rem;

    &:hover:not(.disabled) {
      filter: brightness(1.08);
      background-color: var(--bui-cta-sec-fill, #4b1886);
    }
  }

  :deep(> .flex) {
    display: inline-flex;
    width: auto;
    flex: 0 0 auto;
    justify-content: flex-start;
  }
}
</style>
